export const MIN_ECTS = 57.5
export const MAX_ECTS = 62.5

export const TERMS = [1, 2, 3]
